import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

// context

// compoonents
import { StyledText } from "./basic";

// assets

const DetailsCard = ({ title, details, action, onClick }) => {
  return (
    <Tappable
      onClick={() => {
        onClick();
      }}
    >
      <One>
        <StyledText fontFamily={500} margin={0} size={14}>
          {title}
        </StyledText>
        <StyledText fontFamily={300} margin={0} height={18} size={12}>
          {details}
        </StyledText>
      </One>
      <Button>
        <StyledText color={"white"} size={16}>
          {action}
        </StyledText>
        <FontAwesomeIcon
          style={{ alignSelf: "center", justifySelf: "center" }}
          color={"white"}
          icon={faChevronRight}
        />
      </Button>
    </Tappable>
  );
};

const One = styled.div`
  display: grid;
  padding-left: 13px;
  align-content: center;
  background-color: #e31c79;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  background-color: white;
`;

const Button = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-around;
  background-color: #e31c79;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  padding: 10px;
`;

const Tappable = styled.div`
  display: grid;
  grid-template-columns: 1fr 100px;
  elevation: 4px;
  height: 80px;
  border-radius: 25px;
  margin: 8px 20px;
  border-width: 2px;
  box-shadow: 3px 3px 3px 2px #ccc;
  elevation: 4px;
  @media screen and (max-width: 480px) {
  }
`;

export default DetailsCard;

DetailsCard.propTypes = {};
